<template>
<div class="wrap_service_project wow fadeInUp">
 <el-row>
  <el-col :span="2" class="header_block"></el-col>
  <el-col :span="5" class="header_block server_box" v-for="(item,index) in serviceArray"  :key="index">
       <div class="wrap_advanced">
          <img :src="item.url" class="server_img" />
          <div>
        <p class="server_title">{{item.title}}</p>
        <p class="server_titleEng" v-html="item.titleEng"></p>
          </div>
       </div>
  </el-col>
  <el-col :span="2" class="header_block"></el-col>
</el-row>
</div>
</template>

<script>
export default {
  name: 'serviceProject',
  data() {
    return {
      serviceArray:[
        {url:require('@/assets/imgs/pics01.png'),title:'教育达人经纪服务',titleEng:'旗下合作优质讲师百余人<br /> 专业猎头团队，全网挖掘，高效匹配，致力于为您提供最合适的讲师人选。'},
        {url:require('@/assets/imgs/pics02.png'),title:'专业教研服务',titleEng:'自有教研团队均来自一流在线教育公司，拥有10年以上教研经验，为课程质量保驾护航。'},
        {url:require('@/assets/imgs/pics03.png'),title:'视频课程录制',titleEng:'专业影棚、专业团队、专业设备，可提供绿幕抠像课、实景课、研学课、实验课、手工课多种类课程录制。'},
        {url:require('@/assets/imgs/pics04.png'),title:'课程后期制作',titleEng:'视频剪辑、动画制作累计制作视频课程突破一万小时。'},
      ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrap_service_project{
  .header_block{
    min-height:10px
    }
  }
      .server_box{
      // width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .wrap_advanced{
        width: 85%;
        box-sizing: border-box;
        border: 1px solid #E9E9E9;
        height: 314px;
        background: #fff;
        position: relative;
        display: flex;
        justify-content: center;
        // flex-direction:column;
         box-shadow: 0 28px 46px 0 rgba(0, 0, 0, 0.12);
      }
      .wrap_advanced:hover{ 
    -webkit-animation: pulseText 0.5s linear;
    animation: pulseText 0.5s linear;
    border: 1px solid #E9E9E9;
    box-shadow: 0 28px 46px 0 rgba(0, 0, 0, 0.12);
    transition: all 0.3s ease;
    
    /* box-shadow: 0px 0px 10px 0px rgb(144 147 153 / 30%); */
}


@-webkit-keyframes pulseText {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  
    70% {
      -webkit-transform: scale3d(1.13, 1.13, 1.13);
      transform: scale3d(1.13, 1.13, 1.13);
    }
  
    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
}

@keyframes pulseText {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  
     70% {
      -webkit-transform: scale3d(1.13, 1.13, 1.13);
      transform: scale3d(1.13, 1.13, 1.13);
    }
  
    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
}
      .server_img{
        width: 35%;
        position: absolute;
        margin-top: -18%;

      }
      .server_title{
width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 22px;
    color: #333;
    margin-top: 50px;
    margin-bottom: 30px;
    box-sizing: border-box;
}
.server_titleEng{
width: 100%;
    font-size: 14px;
    color: #999;
    line-height: 30px;
     box-sizing: border-box;
     padding: 0 30px;
}
  
}
</style>



